import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ProductCatalogPage = lazy(() => import('~/features/platform/pages/product-catalog-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/products')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ProductCatalogPage />
    </Suspense>
  ),
});
